export default __webpack_public_path__ + "static/media/HRServicesLebenswerkBusinessManagement.c7996d35.png";